import { FeatureFlagsContext } from "@src/shared/components/FeatureFlags/FeatureFlagsContext";
import { use } from "react";
import { useAuth as useOidcAuth } from "react-oidc-context";

export function useAuth() {
  const { isFeatureEnabled } = use(FeatureFlagsContext);
  const auth = useOidcAuth();

  return {
    ...auth,
    isAuthenticated:
      !isFeatureEnabled("authentication") || auth.isAuthenticated,
  };
}
